/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Bank = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.9661 6.63586L12 1L3.03381 6.63586H5.85245L12 2.77172L18.1475 6.63586H20.9661ZM18.75 9.88586H21V8.38586H3V9.88586H5.25V18.3859H3V19.8859H21V18.3859H18.75V9.88586ZM17.25 9.88586H14.75V18.3859H17.25V9.88586ZM10.75 18.3859V9.88586H13.25V18.3859H10.75ZM6.75 18.3859V9.88586H9.25V18.3859H6.75ZM23 21.3859V22.8859H1V21.3859H23ZM13 5.88586C13 6.43815 12.5523 6.88586 12 6.88586C11.4477 6.88586 11 6.43815 11 5.88586C11 5.33358 11.4477 4.88586 12 4.88586C12.5523 4.88586 13 5.33358 13 5.88586Z"
                        fill={color}
                    />
                </svg>
        );
    };
